import PropTypes from 'prop-types';

export const socialLoginButtonProps = {
  completionPath: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string,
  titleTemplate: PropTypes.string,
  onLogin: PropTypes.func.isRequired,
  onLoginError: PropTypes.func.isRequired,
};

export const socialLoginButtonDefaultProps = {
  disabled: false,
  loading: false,
  className: null,
  titleTemplate: null,
  onLoginStatusChange: null,
  completionPath: '/login/complete',
};
